import { render, staticRenderFns } from "./PrescriptionItemWrapper.vue?vue&type=template&id=ec38a3c4&scoped=true"
import script from "./PrescriptionItemWrapper.vue?vue&type=script&lang=ts"
export * from "./PrescriptionItemWrapper.vue?vue&type=script&lang=ts"
import style0 from "./PrescriptionItemWrapper.vue?vue&type=style&index=0&id=ec38a3c4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec38a3c4",
  null
  
)

export default component.exports